import { Injectable } from '@angular/core';
import { Dialog, DialogButtons, DialogButton } from '../shared/util/dialog/dialog.interfaces';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../shared/util/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  public _dialog: Dialog = null;
  private resolver;

  public _data: {};

  constructor(
    private modal: MatDialog
  ) { }

  async confirm(message: string, title: string = 'Atenção!', subtitle?: string, backdrop?: boolean, disableClose = true): Promise<boolean> {
    const res = await this.dialog({
      message, title, subtitle, backdrop, disableClose,
      buttons: [
        {
          text: 'Não',
          color: 'warn',
          shortcut: {
            shift: true,
            key: 'N'
          }
        },
        {
          text: 'Sim',
          color: 'primary',
          default: true,
          shortcut: {
            shift: true,
            key: 'S'
          }
        }
      ]

    });
    if (res == 'Sim') { return true; }
    return false;
  }

  async confirmWithOptions(options: {
    message: string,
    title: string,
    subtitle?: string,
    backdrop?: boolean,
    disableClose?: boolean,
    yesText?: string;
    noText?: string;
  }): Promise<boolean> {

    const { message, title = 'Atenção', subtitle, backdrop, yesText = 'Sim', noText = 'Não' } = options;
    let { disableClose = true } = options;
    if (!Object.keys(options).includes('disableClose')) {
      disableClose = true;
    }


    const res = await this.dialog({
      message,
      title,
      subtitle,
      backdrop,
      disableClose,
      buttons: [
        {
          text: noText,
          color: 'warn',
          shortcut: {
            shift: true,
            key: 'N'
          }
        },
        {
          text: yesText,
          color: 'primary',
          default: true,
          shortcut: {
            shift: true,
            key: 'S'
          },

        }
      ]

    });
    return res == yesText;
  }


  async informParams(params: {
    message: string,
    title: string,
    subtitle?: string,
    backdrop?: boolean,
    disableClose?: boolean,
    clipboard?: boolean,
    okText?: string;
  }): Promise<boolean> {

    const { message, title, subtitle, backdrop, disableClose = true, clipboard = false, okText = 'Ok' } = params;
    const res = await this.dialog({
      message, title, subtitle, backdrop, disableClose,
      clipboard,
      buttons: [
        {
          text: okText,
          color: 'primary',
          default: true
        }
      ]
    });
    if (res == okText) { return true; }
    return false;
  }

  async inform(message: string, title: string, subtitle?: string, backdrop?: boolean, disableClose = true): Promise<boolean> {
    const res = await this.dialog({
      message, title, subtitle, backdrop, disableClose,
      buttons: [
        {
          text: 'Ok',
          color: 'primary',
          default: true
        }
      ]
    });
    if (res == 'OK') { return true; }
    return false;
  }


  dialog(dialog: DialogButtons): Promise<string> {
    return new Promise((resolve, reject) => {
      this.resolver = resolve;

      this._dialog = {
        message: dialog.message,
        title: dialog.title,
        subtitle: dialog.subtitle,
        backdrop: dialog.backdrop,
        clipboard: dialog.clipboard,
        buttons: this.adjustButtons(dialog.buttons, (button: DialogButton) => {
          this.resolve(button.text);
        })
      };

      this.modal.open(DialogComponent, {
        hasBackdrop: true,
        width: '650px',
        minHeight: '300px',
        maxWidth: '95vw',
        maxHeight: '90vh',
        disableClose: dialog.disableClose,
        data: this._dialog
      });

    });
  }

  async present(title: string, message: string, buttons: string[], backdrop?: boolean, disableClose = true): Promise<string> {

    const _b: DialogButton[] = [];
    buttons.forEach(b => _b.push({
      text: b,
      color: 'primary'
    }));

    return this.dialog({
      title,
      message,
      buttons: _b,
      backdrop,
      disableClose
    });
  }


  private resolve(result: any) {
    if (this.resolver) {
      this.resolver(result);
      this.resolver = null;
    }
    this.dismiss();
  }

  public dismiss(isBackdrop = false) {
    if (isBackdrop && this._dialog.backdrop == false) { return; }
    this._dialog = null;
    this._data = {};
    if (this.resolver) {
      this.resolver(false);
    }
  }

  // Add a handler to the button
  private adjustButtons(buttons: DialogButton[], handler) {
    return buttons.map(button => {
      const _b = Object.assign(button, {
        handle: handler
      });
      return _b;
    });
  }



}
